import getQueryFromUri from './uri';

export const SUPPORTED_DEEP_LINKS = {
  'deliveroo://mgm-sharesheet': 'MGM_INVITE_MODAL',
};

export function getSupportedDeepLink(deepLinkUri) {
  const isSupported = Object.keys(SUPPORTED_DEEP_LINKS).includes(deepLinkUri);

  if (!isSupported) {
    return null;
  }

  return SUPPORTED_DEEP_LINKS[deepLinkUri];
}

export const createSelfHelpQueries = (deepLinkUri) => {
  // the only accepted deep link uri is order help
  let queries = null;
  if (deepLinkUri && deepLinkUri.indexOf('deliveroo://orderhelp/') === 0) {
    queries = getQueryFromUri(deepLinkUri);
  }

  if (
    !queries ||
    !queries.action_id ||
    !queries.action_template ||
    !queries.selected_action_id ||
    !queries.selected_action_template
  ) {
    return null;
  }

  return {
    actionId: queries.action_id,
    actionTemplate: queries.action_template,
    selectedActionId: queries.selected_action_id,
    selectedActionTemplate: queries.selected_action_template,
  };
};
